var r = {
  paddingBlock: {
    value: "{space.xs.value}"
  },
  track: {
    backgroundColor: {
      value: "{colors.background.quaternary.value}"
    },
    borderRadius: {
      value: "9999px"
    },
    height: {
      value: "0.375rem"
    },
    minWidth: {
      value: "10rem"
    }
  },
  range: {
    backgroundColor: {
      value: "{colors.brand.primary.80.value}"
    },
    borderRadius: {
      value: "9999px"
    },
    _disabled: {
      backgroundColor: {
        value: "{colors.background.disabled.value}"
      }
    }
  },
  thumb: {
    width: {
      value: "1.25rem"
    },
    height: {
      value: "1.25rem"
    },
    backgroundColor: {
      value: "{colors.background.primary.value}"
    },
    boxShadow: {
      value: "{shadows.small.value}"
    },
    borderRadius: {
      value: "50%"
    },
    borderWidth: {
      value: "{borderWidths.medium.value}"
    },
    borderColor: {
      value: "{colors.border.primary.value}"
    },
    borderStyle: {
      value: "solid"
    },
    _disabled: {
      backgroundColor: {
        value: "{colors.background.disabled.value}"
      },
      borderColor: {
        value: "transparent"
      },
      boxShadow: {
        value: "none"
      }
    },
    _hover: {
      backgroundColor: {
        value: "{colors.background.primary.value}"
      },
      borderColor: {
        value: "{colors.border.focus.value}"
      }
    },
    _focus: {
      borderColor: {
        value: "{colors.border.focus.value}"
      },
      boxShadow: {
        value: {
          offsetX: "0",
          offsetY: "0",
          blurRadius: "0",
          spreadRadius: "2px",
          color: "{colors.border.focus.value}"
        }
      }
    }
  },
  small: {
    track: {
      height: {
        value: "0.25rem"
      }
    },
    thumb: {
      width: {
        value: "1rem"
      },
      height: {
        value: "1rem"
      }
    }
  },
  large: {
    track: {
      height: {
        value: "0.625rem"
      }
    },
    thumb: {
      width: {
        value: "1.5rem"
      },
      height: {
        value: "1.5rem"
      }
    }
  }
};
export { r as sliderfield };